import {
  createFrontendModule,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const protoBrowserPage = PageBlueprint.make({
  name: 'proto-browser',
  params: {
    path: '/proto-browser',
    title: 'Proto Browser',
    loader: () =>
      import('./ProtoBrowserPage').then(m => <m.ProtoBrowserPage />),
  },
});

export const protoBrowserModule = createFrontendModule({
  pluginId: 'app',
  extensions: [protoBrowserPage],
});
